import * as React from "react";
export function SvgSchemaViewerBlank(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return <svg width={24} height={17} {...props} />;
}
